import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/blade-system/dept/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
// 工种列表 获取specialist列表
export const getSpecialistList = (current, size, params) => request({
  url: '/api/mcc-worker/companyspecialist/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

// businessSection
export const getBusinessSection = (current, size, params) => request({
  url: '/api/blade-system/dept/tree?deptCategory=2&parentId=0',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getDeptLazyList = (deptCategory, parentId) => request({
  url: '/api/blade-system/dept/lazy-list',
  method: 'get',
  params: {
    deptCategory,
    parentId,
  },
})

export const remove = ids => request({
  url: '/api/blade-system/dept/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/dept/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/dept/submit',
  method: 'post',
  data: row,
})

export const getDept = id => request({
  url: '/api/blade-system/dept/detail',
  method: 'get',
  params: {
    id,
  },
})
export const getDeptTree = deptCategory => request({
  url: '/api/blade-system/dept/tree',
  method: 'get',
  params: {
    deptCategory,
  },
})
export const getDeptTreeByQuery = params => request({
  url: '/api/blade-system/dept/tree',
  method: 'get',
  params: {
    ...params,
  },
})

export const getDeptLazyTree = (deptCategory, parentId) => request({
  url: '/api/blade-system/dept/lazy-tree',
  method: 'get',
  params: {
    deptCategory,
    parentId,
  },
})

export const getDeptListTree = (deptCategory, parentId, params) => request({
  url: '/api/blade-system/dept/dept-tree',
  method: 'get',
  params: {
    deptCategory,
    parentId,
    ...params,
  },
})

export const deptTree = params => request({
  url: '/api/blade-system/dept/dept-tree',
  method: 'get',
  params: {
    ...params,
  },
})

export const cardtemplatePage = (current, size, params) => request({
  url: '/api/mcc-base/cardtemplate/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
